import { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import ViewImportDialog from '../../ViewImportDialog';
import { showToastError } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { getImports } from '../../hooks/useImports';

export default function ImportJobViewContainer() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { org } = useLegacyAppSession();
  const jobId = String(params.jobId || '');
  const [job, setJob] = useState(location.state?.job || null);
  const [isLoading, setIsLoading] = useState(!location.state?.job);

  useEffect(() => {
    if (!jobId || !org?.id || job) {
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    getImports(org.id, 0, 200)
      .then((jobs) => {
        if (cancelled) return;
        const match = (jobs || []).find((item) => String(item?.id) === jobId) || null;
        setJob(match);
      })
      .catch(() => {
        if (cancelled) return;
        showToastError('Import job could not be loaded.');
      })
      .finally(() => {
        if (cancelled) return;
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [job, jobId, org?.id]);

  if (!jobId) {
    return <Navigate to="/imports" replace />;
  }

  if (isLoading) {
    return null;
  }

  if (!job) {
    return <Navigate to="/imports" replace />;
  }

  return (
    <ViewImportDialog
      job={job}
      onClose={() => navigate('/imports?tab=history', { replace: true })}
    />
  );
}
